import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Icon = ({ d, size = 16, strokeWidth = 1.75 }) => (
    <svg width={size} height={size} viewBox="0 0 24 24"
        fill="none" stroke="currentColor"
        strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
        {Array.isArray(d) ? d.map((p, i) => <path key={i} d={p} />) : <path d={d} />}
    </svg>
);

const icons = {
    plus: ['M12 5v14', 'M5 12h14'],
    message: ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
    close: ['M18 6L6 18', 'M6 6l12 12'],
    send: ['M22 2L11 13', 'M22 2l-7 20-4-9-9-4 20-7z'],
    back: ['M19 12H5', 'M12 19l-7-7 7-7']
};

const ticketStyles = `
.support-container {
    font-family: 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 24px;
    height: 100%;
    box-sizing: border-box;
    background: #f8fafc;
    padding: 24px;
    border-radius: 16px;
}

.support-panel {
    font-family: 'Inter', sans-serif;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

.support-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 24px;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
}

.support-header h1 { margin: 0 0 4px; font-size: 22px; color: #1e293b; font-weight: 700; }
.support-header p { margin: 0; color: #64748b; font-size: 14px; }

.new-ticket-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #3f51b5, #303f9f);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 4px 12px rgba(63, 81, 181, 0.2);
}
.new-ticket-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(63, 81, 181, 0.3);
}

.ticket-list-wrapper {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    box-shadow: 0 4px 6px -1px rgba(0,0,0,0.02);
}

.modern-table {
    width: 100%;
    border-collapse: collapse;
}
.modern-table th {
    background: #f8fafc;
    padding: 14px 20px;
    text-align: left;
    font-size: 13px;
    text-transform: uppercase;
    color: #64748b;
    font-weight: 600;
    border-bottom: 1px solid #e2e8f0;
}
.modern-table td {
    padding: 16px 20px;
    border-bottom: 1px solid #f1f5f9;
    vertical-align: middle;
}
.modern-table tr { cursor: pointer; transition: background 0.2s; }
.modern-table tr:hover { background: #f8fafc; }

.subject-col .subject-text { font-weight: 600; color: #1e293b; font-size: 14.5px; margin-bottom: 4px; }
.subject-col .subject-desc { color: #94a3b8; font-size: 13px; }

.status-badge { background: #e6f0fa; color: #3f51b5; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 600; }
.priority-badge { background: #fef3c7; color: #b45309; padding: 4px 10px; border-radius: 12px; font-size: 12px; font-weight: 600; }

.view-btn { background: #f1f5f9; color: #475569; border: 1px solid #e2e8f0; padding: 6px 14px; border-radius: 6px; font-size: 13px; font-weight: 600; cursor: pointer; transition: all 0.2s; }
.modern-table tr:hover .view-btn { background: #3f51b5; color: white; border-color: #3f51b5; }

/* Create & View Panels */
.panel-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    border-bottom: 1px solid #e2e8f0;
    padding-bottom: 24px;
    margin-bottom: 24px;
}
.ticket-title-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
}
.panel-header h2 { margin: 0; font-size: 22px; color: #0f172a; font-weight: 800; letter-spacing: -0.01em; }
.back-btn { display: flex; align-items: center; gap: 8px; background: #fff; border: 1px solid #cbd5e1; padding: 10px 16px; border-radius: 10px; font-weight: 600; color: #475569; cursor: pointer; transition: all 0.2s; font-family: 'Inter', sans-serif; box-shadow: 0 2px 4px rgba(0,0,0,0.02); }
.back-btn:hover { background: #f8fafc; color: #1e293b; border-color: #94a3b8; transform: translateY(-1px); }

.panel-body {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px -2px rgba(0,0,0,0.03);
}
.flex-layout { display: flex; padding: 0; min-height: 500px; overflow: hidden; }

.modern-create-form {
    padding: 40px;
    max-width: 800px;
    margin: 0 auto;
}
.ticket-form { display: flex; flex-direction: column; gap: 28px; }
.form-row { display: flex; gap: 24px; }
.form-row.three-cols { display: grid; grid-template-columns: repeat(3, 1fr); gap: 24px; }
.flex-1 { flex: 1; }

.form-group label { display: block; font-size: 12px; font-weight: 700; color: #1e293b; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.05em; }
.req { color: #ef4444; }
.form-group input, .form-group textarea, .form-group select { 
    width: 100%; padding: 16px 20px; border: 1.5px solid #e2e8f0; border-radius: 12px; 
    font-size: 15px; outline: none; transition: all 0.2s ease; font-family: inherit; 
    background: #fff; color: #0f172a; box-sizing: border-box; box-shadow: 0 1px 2px rgba(0,0,0,0.01);
}
.form-group input:hover, .form-group textarea:hover, .form-group select:hover {
    border-color: #cbd5e1;
}
.form-group input:focus, .form-group textarea:focus, .form-group select:focus { 
    border-color: #3b82f6; background: #fff; box-shadow: 0 0 0 4px rgba(59,130,246,0.1); 
}

.form-actions { display: flex; justify-content: flex-end; gap: 12px; margin-top: 8px; border-top: 1px solid #e2e8f0; padding-top: 24px; }
.btn-secondary { background: #f1f5f9; color: #475569; border: none; padding: 12px 24px; border-radius: 8px; font-weight: 600; font-size: 15px; cursor: pointer; transition: 0.2s; font-family: 'Inter', sans-serif;}
.btn-secondary:hover { background: #e2e8f0; color: #1e293b; }

.submit-ticket-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #2563eb, #1d4ed8);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    transition: 0.2s;
    box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
    font-family: 'Inter', sans-serif;
}
.submit-ticket-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 16px rgba(37, 99, 235, 0.3); }

/* Chat view */
.ticket-chat { flex: 1; display: flex; flex-direction: column; border-right: 1px solid #e2e8f0; background: #f8fafc; }
.messages-container { flex: 1; padding: 24px; display: flex; flex-direction: column; gap: 20px; overflow-y: auto; }
.message { padding: 20px 24px; border-radius: 16px; background: #fff; border: 1px solid #e2e8f0; box-shadow: 0 2px 8px rgba(0,0,0,0.02); }
.original-message { border-left: 4px solid #2563eb; }
.reply-message { border-left: 4px solid #10b981; }
.msg-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px; padding-bottom: 12px; border-bottom: 1px solid #f1f5f9; }
.msg-header strong { color: #1e293b; font-size: 15px; font-weight: 700; display: flex; align-items: center; gap: 8px; }
.msg-header span { color: #64748b; font-size: 12px; font-weight: 500; }
.msg-body { color: #334155; font-size: 14.5px; line-height: 1.6; white-space: pre-wrap; }

.reply-box { padding: 24px; background: #fff; border-top: 1px solid #e2e8f0; }
.reply-box textarea { width: 100%; padding: 16px 20px; border: 1px solid #cbd5e1; border-radius: 12px; resize: vertical; font-family: inherit; font-size: 14.5px; margin-bottom: 16px; outline: none; transition: all 0.2s; box-sizing: border-box; background: #f8fafc; }
.reply-box textarea:focus { border-color: #2563eb; background: #fff; box-shadow: 0 0 0 3px rgba(37,99,235,0.1); }
.reply-actions { display: flex; justify-content: flex-end; }
.reply-actions button { display: flex; align-items: center; gap: 8px; background: #2563eb; color: white; border: none; padding: 12px 24px; border-radius: 10px; font-weight: 600; cursor: pointer; transition: 0.2s; box-shadow: 0 4px 10px rgba(37,99,235,0.2); }
.reply-actions button:hover:not(:disabled) { background: #1d4ed8; transform: translateY(-1px); box-shadow: 0 6px 14px rgba(37,99,235,0.3); }
.reply-actions button:disabled { opacity: 0.5; cursor: not-allowed; box-shadow: none; }

.ticket-sidebar { width: 320px; padding: 32px; background: #fff; }
.ticket-sidebar h3 { margin: 0 0 24px; font-size: 15px; text-transform: uppercase; letter-spacing: 0.05em; color: #475569; font-weight: 700; }
.info-row { display: flex; flex-direction: column; gap: 6px; margin-bottom: 20px; font-size: 14px; padding-bottom: 16px; border-bottom: 1px solid #f1f5f9; }
.info-row:last-child { border-bottom: none; }
.info-row span { color: #64748b; font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: 0.05em; }
.info-row strong { color: #1e293b; font-size: 15px; }

/* Toast */
.notification-toast {
    position: fixed;
    bottom: 30px;
    right: 30px;
    background: #10b981;
    color: white;
    padding: 16px 24px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    gap: 12px;
    font-weight: 600;
    box-shadow: 0 10px 25px rgba(16, 185, 129, 0.3);
    animation: slideUp 0.3s ease;
    z-index: 1000;
}
@keyframes slideUp { from { transform: translateY(100px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }

.empty-state { text-align: center; padding: 60px 20px; }
.empty-icon { width: 64px; height: 64px; background: #f1f5f9; color: #94a3b8; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; }
.empty-state h3 { color: #1e293b; font-size: 18px; margin: 0 0 8px; }
.empty-state p { color: #64748b; font-size: 14px; margin: 0 0 20px; }
.empty-state button { background: #fff; border: 1px solid #cbd5e1; padding: 10px 20px; border-radius: 8px; font-weight: 600; color: #475569; cursor: pointer; }
.empty-state button:hover { background: #f8fafc; color: #1e293b; }
`;

export default function SupportTickets({ context, userDetails, trips = [] }) {
    const [tickets, setTickets] = useState([]);
    const [activeTab, setActiveTab] = useState('internal'); // 'internal', 'superadmin'
    const [loading, setLoading] = useState(true);
    const [view, setView] = useState('list'); // 'list', 'create', 'create-superadmin', 'view'
    const [selectedTicket, setSelectedTicket] = useState(null);
    const [formData, setFormData] = useState({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null });
    const [replyContent, setReplyContent] = useState('');
    const [showNotification, setShowNotification] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [services, setServices] = useState([]);
    const [priorities, setPriorities] = useState([]);
    const [users, setUsers] = useState([]);
    const [vendors, setVendors] = useState([]);
    const [dispatchVendorId, setDispatchVendorId] = useState('');

    useEffect(() => {
        fetchTickets();
        fetchMasterData();
    }, [context, userDetails]);

    const fetchMasterData = async () => {
        try {
            const promises = [
                axios.get('/api/departments/all'),
                axios.get('/api/services'),
                axios.get('/api/master-data')
            ];

            if (context === 'operator' || context === 'admin') {
                const opId = userDetails._id || userDetails.operatorId;
                if (opId) {
                    promises.push(axios.get(`/api/users/${opId}`));
                    promises.push(axios.get(`/api/vendors/${opId}`));
                }
            }

            const results = await Promise.all(promises);
            setDepartments(results[0].data);
            setServices(results[1].data);
            setPriorities(results[2].data.filter(i => i.category === 'ticket-priority' && i.active !== false));
            
            if (results[3]) {
                setUsers(results[3].data);
            }
            if (results[4]) {
                setVendors(results[4].data);
            }
        } catch (err) {
            console.error('Error fetching master data:', err);
        }
    };

    const fetchTickets = async () => {
        setLoading(true);
        try {
            let url = '/api/tickets';
            if (context === 'client') {
                url += `?clientId=${userDetails._id}`;
            } else if (context === 'vendor') {
                url += `?vendorId=${userDetails._id}`;
            } else if (context === 'operator') {
                url += `?operatorId=${userDetails._id || userDetails.operatorId}`;
            }
            const res = await axios.get(url);
            setTickets(res.data);
        } catch (err) {
            console.error('Error fetching tickets:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleCreateTicket = async (e) => {
        e.preventDefault();
        if (!formData.subject || !formData.description) return alert("Subject and Description are required");

        const newTicket = {
            subject: formData.subject,
            description: formData.description,
            department: formData.department || undefined,
            service: formData.service || undefined,
            priority: formData.priority || undefined,
            assignee: formData.assignee || undefined,
            tripId: formData.tripId || undefined,
            contactName: userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName,
            contactEmail: userDetails.email,
            createdByRole: context.charAt(0).toUpperCase() + context.slice(1),
        };

        if (context === 'client') {
            newTicket.clientId = userDetails._id;
            newTicket.operatorId = userDetails.operatorId;
        } else if (context === 'vendor') {
            newTicket.vendorId = userDetails._id;
            newTicket.operatorId = userDetails.operatorId;
        } else if (context === 'operator') {
            newTicket.operatorId = userDetails._id || userDetails.operatorId;
        }

        try {
            await axios.post('/api/tickets', newTicket);
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 3000);
            setView('list');
            setFormData({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null });
            fetchTickets();
        } catch (err) {
            console.error('Error creating ticket:', err);
            alert("Failed to create ticket.");
        }
    };

    const handleCreateSuperadminTicket = async (e) => {
        e.preventDefault();
        if (!formData.subject || !formData.description) return alert("Subject and Description are required");

        const newTicket = {
            subject: formData.subject,
            description: formData.description,
            priority: formData.priority || undefined,
            department: formData.department || undefined,
            service: formData.service || undefined,
            issueType: formData.issueType || undefined,
            contact: formData.contact || undefined,
            contactName: formData.contactName || (userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName),
            contactEmail: formData.contactEmail || userDetails.email,
            createdByRole: 'Operator',
            operatorId: userDetails._id || userDetails.operatorId,
            tags: formData.tags ? formData.tags.split(',').map(t => t.trim()) : ['To Superadmin']
        };

        try {
            if (formData.attachment) {
                const uploadData = new FormData();
                uploadData.append('document', formData.attachment);
                const uploadRes = await axios.post('/upload', uploadData);
                newTicket.attachment = uploadRes.data.filename || (uploadRes.data.filenames && uploadRes.data.filenames[0]);
            }
            await axios.post('/api/tickets', newTicket);
            setShowNotification(true);
            setTimeout(() => setShowNotification(false), 3000);
            setView('list');
            setFormData({ subject: '', description: '', department: '', service: '', priority: '', assignee: '', tripId: '', issueType: '', attachment: null });
            fetchTickets();
        } catch (err) {
            console.error('Error creating superadmin ticket:', err);
            alert("Failed to create ticket.");
        }
    };

    const handleReply = async (e) => {
        e.preventDefault();
        if (!replyContent) return;
        try {
            await axios.post(`/api/tickets/${selectedTicket._id}/replies`, {
                user: userDetails.firstName ? `${userDetails.firstName} ${userDetails.lastName || ''}` : userDetails.companyName || userDetails.vendorName || 'User',
                content: replyContent,
                type: 'reply',
                senderRole: context.charAt(0).toUpperCase() + context.slice(1)
            });
            setReplyContent('');
            // Refresh ticket
            const res = await axios.get(`/api/tickets/${selectedTicket._id}`);
            setSelectedTicket(res.data);
            fetchTickets(); // update list to get latest reply date
        } catch (err) {
            console.error('Error sending reply:', err);
            alert("Failed to send reply.");
        }
    };

    if (view === 'create') {
        return (
            <div className="support-panel">
                <style>{ticketStyles}</style>
                <div className="panel-header">
                    <button className="back-btn" onClick={() => setView('list')}><Icon d={icons.back} /> Back</button>
                    <h2>Create New Ticket</h2>
                </div>
                <div className="panel-body">
                    <form onSubmit={handleCreateTicket} className="ticket-form modern-create-form">
                        <div className="form-row">
                            <div className="form-group flex-1">
                                <label>Subject <span className="req">*</span></label>
                                <input 
                                    type="text" 
                                    placeholder="Brief description of the issue"
                                    value={formData.subject}
                                    onChange={e => setFormData({ ...formData, subject: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                        
                        <div className="form-row three-cols">
                            <div className="form-group">
                                <label>Department</label>
                                <select value={formData.department} onChange={e => setFormData({ ...formData, department: e.target.value })}>
                                    <option value="">Select Department...</option>
                                    {departments.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Service Category</label>
                                <select value={formData.service} onChange={e => setFormData({ ...formData, service: e.target.value })}>
                                    <option value="">Select Service...</option>
                                    {services.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Priority</label>
                                <select value={formData.priority} onChange={e => setFormData({ ...formData, priority: e.target.value })}>
                                    <option value="">Select Priority...</option>
                                    {priorities.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                                </select>
                            </div>
                        </div>

                        {context === 'operator' && (
                            <div className="form-row">
                                <div className="form-group flex-1">
                                    <label>Assign To</label>
                                    <select value={formData.assignee} onChange={e => setFormData({ ...formData, assignee: e.target.value })}>
                                        <option value="">Unassigned</option>
                                        {users.map(u => <option key={u._id} value={u._id}>{u.firstName} {u.lastName}</option>)}
                                    </select>
                                </div>
                            </div>
                        )}

                        { (context === 'client' || context === 'vendor') && trips && trips.length > 0 && (
                            <div className="form-row">
                                <div className="form-group flex-1">
                                    <label>Select Trip (Optional)</label>
                                    <select value={formData.tripId} onChange={e => setFormData({ ...formData, tripId: e.target.value })}>
                                        <option value="">-- General Issue --</option>
                                        {trips.map(t => (
                                            <option key={t._id} value={t._id}>
                                                {t.tripName || t.name || t.routeName || 'Trip'} ({t.tripId || t._id.substring(0, 8)})
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}

                        <div className="form-group">
                            <label>Description <span className="req">*</span></label>
                            <textarea 
                                rows="8" 
                                placeholder="Please provide detailed information about your issue..."
                                value={formData.description}
                                onChange={e => setFormData({ ...formData, description: e.target.value })}
                                required
                            ></textarea>
                        </div>
                        
                        <div className="form-actions">
                            <button type="button" className="btn-secondary" onClick={() => setView('list')}>Cancel</button>
                            <button type="submit" className="submit-ticket-btn">
                                <Icon d={icons.send} /> Submit Ticket
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    if (view === 'create-superadmin') {
        return (
            <div className="support-panel">
                <style>{ticketStyles}</style>
                <div className="panel-header">
                    <button className="back-btn" onClick={() => setView('list')}><Icon d={icons.back} /> Back</button>
                    <h2>Raise Ticket to Superadmin</h2>
                </div>
                <div className="panel-body">
                    <form onSubmit={handleCreateSuperadminTicket} className="ticket-form modern-create-form">
                        <div className="form-row">
                            <div className="form-group flex-1">
                                <label>Subject <span className="req">*</span></label>
                                <input 
                                    type="text" 
                                    placeholder="Brief description of the issue"
                                    value={formData.subject}
                                    onChange={e => setFormData({ ...formData, subject: e.target.value })}
                                    required
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group flex-1">
                                <label>Priority</label>
                                <select value={formData.priority} onChange={e => setFormData({ ...formData, priority: e.target.value })}>
                                    <option value="">Select Priority...</option>
                                    {priorities.map(p => <option key={p._id} value={p._id}>{p.name}</option>)}
                                </select>
                            </div>
                        </div>
                        <div className="form-row three-cols">
                            <div className="form-group flex-1">
                                <label>Department</label>
                                <select value={formData.department} onChange={e => setFormData({ ...formData, department: e.target.value })}>
                                    <option value="">Select Department...</option>
                                    {departments && departments.map(d => <option key={d._id} value={d._id}>{d.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group flex-1">
                                <label>Service Category</label>
                                <select value={formData.service} onChange={e => setFormData({ ...formData, service: e.target.value })}>
                                    <option value="">Select Service...</option>
                                    {services && services.map(s => <option key={s._id} value={s._id}>{s.name}</option>)}
                                </select>
                            </div>
                            <div className="form-group flex-1">
                                <label>Related To (Type)</label>
                                <select value={formData.issueType} onChange={e => setFormData({ ...formData, issueType: e.target.value })}>
                                    <option value="">Select Type...</option>
                                    <option value="Billing & Payments">Billing & Payments</option>
                                    <option value="Technical Support">Technical Support</option>
                                    <option value="Feature Request">Feature Request</option>
                                    <option value="Account Management">Account Management</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-row three-cols">
                            <div className="form-group flex-1">
                                <label>Contact Name</label>
                                <input 
                                    type="text" 
                                    placeholder="Your Name"
                                    value={formData.contactName || ''}
                                    onChange={e => setFormData({ ...formData, contactName: e.target.value })}
                                />
                            </div>
                            <div className="form-group flex-1">
                                <label>Contact Email</label>
                                <input 
                                    type="email" 
                                    placeholder="Your Email"
                                    value={formData.contactEmail || ''}
                                    onChange={e => setFormData({ ...formData, contactEmail: e.target.value })}
                                />
                            </div>
                            <div className="form-group flex-1">
                                <label>Contact Number</label>
                                <input 
                                    type="text" 
                                    placeholder="Your Phone Number"
                                    value={formData.contact || ''}
                                    onChange={e => setFormData({ ...formData, contact: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group flex-1">
                                <label>Tags (Comma separated)</label>
                                <input 
                                    type="text" 
                                    placeholder="e.g. urgent, billing, api"
                                    value={formData.tags || ''}
                                    onChange={e => setFormData({ ...formData, tags: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-group flex-1">
                                <label>Attachment (Optional)</label>
                                <input 
                                    type="file" 
                                    onChange={e => setFormData({ ...formData, attachment: e.target.files[0] })}
                                    style={{ padding: '10px', background: '#fff' }}
                                />
                            </div>
                        </div>
                        <div className="form-group">
                            <label>Description <span className="req">*</span></label>
                            <textarea 
                                rows="8" 
                                placeholder="Please provide detailed information about your issue for the Superadmin..."
                                value={formData.description}
                                onChange={e => setFormData({ ...formData, description: e.target.value })}
                                required
                            ></textarea>
                        </div>
                        
                        <div className="form-actions">
                            <button type="button" className="btn-secondary" onClick={() => setView('list')}>Cancel</button>
                            <button type="submit" className="submit-ticket-btn" style={{ background: 'linear-gradient(135deg, #10b981, #059669)' }}>
                                <Icon d={icons.send} /> Send to Superadmin
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    if (view === 'view' && selectedTicket) {
        return (
            <div className="support-panel">
                <style>{ticketStyles}</style>
                <div className="panel-header">
                    <button className="back-btn" onClick={() => setView('list')}><Icon d={icons.back} /> Back</button>
                    <div className="ticket-title-wrap">
                        <h2>{selectedTicket.subject}</h2>
                        <span className="status-badge" style={{ background: '#f8fafc', border: '1px solid #e2e8f0', color: '#475569', padding: '6px 12px', fontSize: '13px' }}>{selectedTicket.status?.name || 'Open'}</span>
                    </div>
                </div>
                <div className="panel-body flex-layout">
                    <div className="ticket-chat">
                        <div className="messages-container">
                            <div className="message original-message">
                                <div className="msg-header">
                                    <strong><Icon d={icons.message} size={16}/> {selectedTicket.contactName || 'User'} <span style={{ color: '#94a3b8', fontSize: '12px', fontWeight: 'normal', marginLeft: '4px' }}>({selectedTicket.createdByRole || 'Client'})</span></strong>
                                    <span>{new Date(selectedTicket.createdAt).toLocaleString()}</span>
                                </div>
                                <div className="msg-body">{selectedTicket.description}</div>
                            </div>

                            {selectedTicket.replies?.map((reply, idx) => (
                                <div key={idx} className="message reply-message">
                                    <div className="msg-header">
                                        <strong><Icon d={icons.message} size={16}/> {reply.user}</strong>
                                        <span>{new Date(reply.createdAt).toLocaleString()}</span>
                                    </div>
                                    <div className="msg-body">{reply.content}</div>
                                </div>
                            ))}
                        </div>

                        {context === 'operator' && !selectedTicket.tags?.includes('To Superadmin') && (
                            <div style={{ padding: '16px 24px', background: '#fff', borderTop: '1px solid #e2e8f0', display: 'flex', gap: '12px', alignItems: 'center' }}>
                                <label style={{ fontSize: '13px', fontWeight: 700, color: '#475569' }}>Dispatch to Vendor:</label>
                                <select 
                                    style={{ flex: 1, padding: '10px 14px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '14px', outline: 'none' }}
                                    value={dispatchVendorId}
                                    onChange={e => setDispatchVendorId(e.target.value)}
                                >
                                    <option value="">-- Select Vendor --</option>
                                    {vendors.map(v => <option key={v._id} value={v._id}>{v.vendorName}</option>)}
                                </select>
                                <button 
                                    style={{ background: '#10b981', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', fontWeight: 600, cursor: 'pointer' }}
                                    disabled={!dispatchVendorId}
                                    onClick={async () => {
                                        if(!dispatchVendorId) return;
                                        try {
                                            await axios.put(`/api/tickets/${selectedTicket._id}`, { vendorId: dispatchVendorId });
                                            alert("Ticket dispatched to vendor successfully.");
                                            fetchTickets();
                                            const res = await axios.get(`/api/tickets/${selectedTicket._id}`);
                                            setSelectedTicket(res.data);
                                            setDispatchVendorId('');
                                        } catch (e) {
                                            console.error(e);
                                            alert("Failed to dispatch ticket.");
                                        }
                                    }}
                                >
                                    Dispatch
                                </button>
                            </div>
                        )}

                        <div className="reply-box">
                            <form onSubmit={handleReply}>
                                <textarea 
                                    placeholder="Type your reply here..." 
                                    rows="3"
                                    value={replyContent}
                                    onChange={e => setReplyContent(e.target.value)}
                                ></textarea>
                                <div className="reply-actions">
                                    <button type="submit" disabled={!replyContent.trim()}><Icon d={icons.send} /> Send Reply</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="ticket-sidebar">
                        <h3>Ticket Info</h3>
                        <div className="info-row">
                            <span>Status:</span>
                            <strong>{selectedTicket.status?.name || 'Open'}</strong>
                        </div>
                        <div className="info-row">
                            <span>Priority:</span>
                            <strong>{selectedTicket.priority?.name || 'Normal'}</strong>
                        </div>
                        <div className="info-row">
                            <span>Department:</span>
                            <strong>{selectedTicket.department?.name || 'General'}</strong>
                        </div>
                        <div className="info-row">
                            <span>Created:</span>
                            <strong>{new Date(selectedTicket.createdAt).toLocaleDateString()}</strong>
                        </div>
                        <div className="info-row">
                            <span>From:</span>
                            <strong>{selectedTicket.createdByRole || 'User'}</strong>
                        </div>
                        {selectedTicket.createdByRole === 'Passenger' && selectedTicket.clientId && (
                            <div className="info-row">
                                <span>Client:</span>
                                <strong>{selectedTicket.clientId.companyName}</strong>
                            </div>
                        )}
                        {selectedTicket.issueType && (
                            <div className="info-row">
                                <span>Related To:</span>
                                <strong>{selectedTicket.issueType}</strong>
                            </div>
                        )}
                        <div className="info-row">
                            <span>Attachment:</span>
                            {selectedTicket.attachment ? (
                                <a href={`/uploads/${selectedTicket.attachment}`} target="_blank" rel="noreferrer" style={{ color: '#2563eb', fontWeight: 600, textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}>
                                    <Icon d={icons.download} size={14} /> View File
                                </a>
                            ) : <strong>None</strong>}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="support-container">
            {showNotification && (
                <div className="notification-toast">
                    <Icon d={icons.message} /> Ticket Sent Successfully!
                </div>
            )}
            
            <div className="support-header">
                <div>
                    <h1>Support Tickets</h1>
                    <p>Manage and track your support requests</p>
                </div>
                <div style={{ display: 'flex', gap: '12px' }}>
                    {context === 'operator' && (
                        <button className="new-ticket-btn" style={{ background: 'linear-gradient(135deg, #10b981, #059669)' }} onClick={() => setView('create-superadmin')}>
                            <Icon d={icons.send} /> Raise Ticket to Superadmin
                        </button>
                    )}
                    <button className="new-ticket-btn" onClick={() => setView('create')}>
                        <Icon d={icons.plus} /> Create Ticket
                    </button>
                </div>
            </div>

            <div className="ticket-list-wrapper">
                {context === 'operator' && (
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '1px solid #e2e8f0', paddingBottom: '10px' }}>
                        <button 
                            onClick={() => setActiveTab('internal')}
                            style={{ background: 'none', border: 'none', padding: '8px 16px', fontSize: '14.5px', fontWeight: 600, cursor: 'pointer', color: activeTab === 'internal' ? '#2563eb' : '#64748b', borderBottom: activeTab === 'internal' ? '2px solid #2563eb' : '2px solid transparent' }}
                        >
                            Client & Vendor Tickets
                        </button>
                        <button 
                            onClick={() => setActiveTab('passenger')}
                            style={{ background: 'none', border: 'none', padding: '8px 16px', fontSize: '14.5px', fontWeight: 600, cursor: 'pointer', color: activeTab === 'passenger' ? '#2563eb' : '#64748b', borderBottom: activeTab === 'passenger' ? '2px solid #2563eb' : '2px solid transparent' }}
                        >
                            Passenger Support
                        </button>
                        <button 
                            onClick={() => setActiveTab('driver')}
                            style={{ background: 'none', border: 'none', padding: '8px 16px', fontSize: '14.5px', fontWeight: 600, cursor: 'pointer', color: activeTab === 'driver' ? '#2563eb' : '#64748b', borderBottom: activeTab === 'driver' ? '2px solid #2563eb' : '2px solid transparent' }}
                        >
                            Driver Support
                        </button>
                        <button 
                            onClick={() => setActiveTab('superadmin')}
                            style={{ background: 'none', border: 'none', padding: '8px 16px', fontSize: '14.5px', fontWeight: 600, cursor: 'pointer', color: activeTab === 'superadmin' ? '#2563eb' : '#64748b', borderBottom: activeTab === 'superadmin' ? '2px solid #2563eb' : '2px solid transparent' }}
                        >
                            Tickets to Superadmin
                        </button>
                    </div>
                )}

                {(() => {
                    const filteredTickets = tickets.filter(t => {
                        if (context !== 'operator') return true;
                        if (activeTab === 'superadmin') return t.tags?.includes('To Superadmin');
                        if (activeTab === 'passenger') return t.createdByRole === 'Passenger';
                        if (activeTab === 'driver') return t.createdByRole === 'Driver';
                        return !t.tags?.includes('To Superadmin') && t.createdByRole !== 'Passenger' && t.createdByRole !== 'Driver';
                    });

                    if (loading) {
                        return <div className="loading-state">Loading tickets...</div>;
                    }

                    if (filteredTickets.length === 0) {
                        return (
                            <div className="empty-state">
                                <div className="empty-icon"><Icon d={icons.message} size={32} /></div>
                                <h3>No tickets found</h3>
                                <p>There are no support tickets in this category.</p>
                                <button onClick={() => setView('create')}>Create your first ticket</button>
                            </div>
                        );
                    }

                    return (
                    <table className="modern-table">
                        <thead>
                            <tr>
                                <th>Subject</th>
                                <th>Status</th>
                                <th>Priority</th>
                                <th>From</th>
                                <th>Last Updated</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredTickets.map(ticket => (
                                <tr key={ticket._id} onClick={() => { setSelectedTicket(ticket); setView('view'); }}>
                                    <td className="subject-col">
                                        <div className="subject-text">{ticket.subject}</div>
                                        <div className="subject-desc">{ticket.description?.substring(0, 50)}...</div>
                                    </td>
                                    <td><span className="status-badge">{ticket.status?.name || 'Open'}</span></td>
                                    <td><span className="priority-badge">{ticket.priority?.name || 'Normal'}</span></td>
                                    <td style={{ color: '#64748b', fontSize: '13px' }}>
                                        {ticket.createdByRole || 'User'}: {ticket.contactName || 'Unknown'}
                                        {ticket.createdByRole === 'Passenger' && ticket.clientId && (
                                            <span style={{ display: 'block', fontSize: '11px', color: '#94a3b8', marginTop: '2px' }}>
                                                Client: {ticket.clientId.companyName}
                                            </span>
                                        )}
                                    </td>
                                    <td style={{ color: '#64748b', fontSize: '13px' }}>{new Date(ticket.lastReply || ticket.createdAt).toLocaleDateString()}</td>
                                    <td>
                                        <button className="view-btn">View</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    );
                })()}
            </div>
            <style>{ticketStyles}</style>
        </div>
    );
}
